import posthog from 'posthog-js'
import { getClientRuntimeConfig, isDevelopment } from '@/utils/client-runtime-config'

export const initializePostHog = () => {
  if (typeof window !== 'undefined') {
    let posthogKey;
    let posthogHost;
    
    try {
      const config = getClientRuntimeConfig()
      posthogKey = config.POSTHOG_KEY
      posthogHost = config.POSTHOG_HOST

      // Only initialize PostHog if we have the required environment variables
      // and we're not in development mode (unless explicitly enabled)
      if (!posthogKey || !posthogHost) {
        console.log('[PostHog] Skipping initialization - missing environment variables')
        return
      }

      // Skip in development unless explicitly enabled
      if (isDevelopment()) {
        console.log('[PostHog] Skipping initialization in development mode')
        return
      }
    } catch (error) {
      console.warn('[PostHog] Failed to get runtime config, skipping initialization:', error)
      return
    }

    posthog.init(posthogKey, {
      api_host: posthogHost,
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true
        }
      },
      loaded: (posthog) => {
        if (isDevelopment()) posthog.debug()
      }
    })
    
    // Set up global error tracking
    window.addEventListener('error', (event) => {
      if (posthog.__loaded) {
        posthog.capture('$exception', {
          $exception_message: event.message,
          $exception_source: event.filename,
          $exception_lineno: event.lineno,
          $exception_colno: event.colno,
          $exception_stack: event.error?.stack
        })
      }
    })
    
    window.addEventListener('unhandledrejection', (event) => {
      if (posthog.__loaded) {
        posthog.capture('$exception', {
          $exception_message: event.reason?.message || 'Unhandled Promise Rejection',
          $exception_type: 'unhandledrejection',
          $exception_stack: event.reason?.stack
        })
      }
    })
  }
}

export { posthog }